module.exports = __webpack_public_path__ + "img/website_icon_black.71771ed5.svg";